var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery-bar-wrapper"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center gallery-bar"},[_c('h6',{staticClass:"mb-0 mr-3"},[_vm._v(_vm._s(_vm.title))]),(_vm.hasPriceList)?_c('PriceListButton',{on:{"click":_vm.showPriceList}}):_vm._e()],1),_c('div',{staticClass:"separator mx-auto"})])
}
var staticRenderFns = []

export { render, staticRenderFns }